import { Icon } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Tooltip } from '@/components/v4';

const FieldToolTip = ({
    label,
    ariaLabel,
    top,
    left,
    bottom,
    right,
    placement,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <Tooltip
            hasArrow
            placement={placement}
            label={label}
            aria-label={ariaLabel}>
            <Icon
                color={darkMode ? 'white' : undefined}
                position="relative"
                marginLeft="-14px !important"
                top={top}
                left={left}
                right={right}
                bottom={bottom}
            />
        </Tooltip>
    );
};

export default FieldToolTip;
